import React from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import clsx from 'clsx'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  field: {
    '& div': {
      color: theme.black,
      fontSize: theme.fontSizes.default,
      display: 'flex',
      flexDirection: 'column',
    },
  },
}))

interface DocumentReadOnlyFieldProps {
  value: string,
  label?: string,
  customClass?: object | string,
  formatter?: { (v: string): string }
}

const DocumentReadOnlyField = (props: DocumentReadOnlyFieldProps) => {
  const classes = useStyles()

  const { customClass, label, formatter, value } = props

  return (
    <div className={clsx(classes.field, customClass)}>
      {label ? <label>{label}</label> : null}
      <div>
        <span>{formatter ? formatter(value) : value}</span>
      </div>
    </div>
  )
}

export default DocumentReadOnlyField
